//系统设置
export default [
  {
    path: '/organization',
    component: () => import("../pages/system/organization.vue"),
    name: 'Organization',
    title: '系统用户管理',
    meta: {
      title: '系统用户管理',
    },
  },
  {
    path: '/incomeDepartment',
    component: () => import("../pages/system/incomeDepartment.vue"),
    name: 'incomeDepartment',
    title: '经营部门管理',
    meta: {
      title: '经营部门管理',
    },
  },
  {
    path: '/addRole',
    component: () => import("../pages/system/addRole.vue"),
    name: 'AddRole',
    title: '系统角色管理',
    meta: {
      title: '系统角色管理',
    },
  },
  {
    path: '/employeeRights',
    component: () => import("../pages/system/departmentInfor.vue"),
    name: 'EmployeeRights',
    title: '员工列表',
    meta: {
      title: '员工列表',
    },
  },
  {
    path: '/departmentInfor',
    component: () => import("../pages/system/employeeRights.vue"),
    name: 'DepartmentInfor',
    title: '部门管理',
    meta: {
      title: '部门管理',
    },
  },
  {
    path: '/addOffice',
    component: () => import("../pages/system/addOffice.vue"),
    name: 'AddOffice',
    title: '添加用户',
    meta: {
      title: '添加用户',
    },
  },
  {
    path: '/permissions',
    component: () => import("../pages/system/permissions.vue"),
    name: 'Permissions',
    title: '系统角色管理',
    meta: {
      title: '系统角色管理',
    },
  },
  {
    path: '/map',
    component: () => import("../pages/system/mapGarden.vue"),
    name: 'map',
    title: '园区地图',
    meta: {
      title: '园区地图',
    },
  },
  {
    path: '/mapManage',
    component: () => import("../pages/system/mapManage.vue"),
    name: 'mapManage',
    title: '园区地图管理',
    meta: {
      title: '园区地图管理',
    },
  },
  {
    path: '/QAManage',
    component: () => import("../pages/system/QAManage.vue"),
    name: 'QAManage',
    title: 'QA管理',
    meta: {
      title: 'QA管理',
    },
  },
  {
    path: '/certificationManage',
    component: () => import("../pages/system/certificationManage.vue"),
    name: 'certificationManage',
    title: '业主认证管理',
    meta: {
      title: '业主认证管理',
    },
  },
  {
    path: '/certificationStaffManage',
    component: () => import("../pages/system/certificationStaffManage.vue"),
    name: 'certificationStaffManage',
    title: '员工认证管理',
    meta: {
      title: '员工认证管理',
    },
  },
  {
    path: "/lotteryManage",
    component: () => import("../pages/system/lotteryManage/lotteryManage.vue"),
    name: 'lotteryManage',
    title: '抽奖配置',
    meta: {
      title: '抽奖配置',
    },
  },
  {
    path: "/appConfig",
    component: () => import("../pages/system/appConfig.vue"),
    name: 'appConfig',
    title: '应用配置',
    meta: {
      title: '应用配置',
    },
  },
  {
    path: "/appUpgradeCenter",
    component: () => import("../pages/system/appUpgradeCenter.vue"),
    name: 'appUpgradeCenter',
    title: 'App升级中心',
    meta: {
      title: 'App升级中心',
    },
  }
]
